export enum Currency {
    BRL = 'BRL',
    USD = 'USD',
    EUR = 'EUR'
} 